module.exports = __webpack_public_path__ + "media/notif_emergency.54389c97.ogg";